import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  href,
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 active:scale-95';
  const variants = {
    primary: 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg shadow-blue-600/30 hover:shadow-blue-600/50',
    secondary: 'bg-slate-900 text-white hover:bg-slate-800 shadow-lg',
    outline: 'border-2 border-slate-700 text-white hover:border-slate-600 hover:bg-slate-800'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl'
  };
  const classes = `${baseStyles} ${variants[variant]} ${sizes[size]} ${fullWidth ? 'w-full' : ''} ${className}`;
  if (href) {
    const isExternal = href.startsWith('http');
    return <a href={href} className={classes} {...isExternal ? {
      target: '_blank',
      rel: 'noopener noreferrer'
    } : {}} data-id="element-216">
        {children}
      </a>;
  }
  return <button className={classes} {...props} data-id="element-217">
      {children}
    </button>;
}